import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#514E5F",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 11,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function createData(sexo, edad, n, ngram, freq) {
  return { sexo, edad, n, ngram, freq };
}


const useStyles = makeStyles({
  table: {
    minWidth: '100%',
  },
});

export default function TableTrendSexoEdad(props) {
  let dataTable = props.data;
  let rows = null

  let getRows = () => {
    rows = dataTable.map(registro => createData(
      registro.Sexo, 
      registro.Edad, 
      registro.n, 
      registro.ngram,
      registro.freq
      ));
    
    return rows.map((row, index) => (
      <StyledTableRow key={index}>
        <StyledTableCell style={{padding: 10}} component="th" scope="row">
          {row.sexo}
        </StyledTableCell>
        <StyledTableCell style={{padding: 10}} align="right">{row.edad}</StyledTableCell>
        <StyledTableCell style={{padding: 10}} align="right">{row.n}</StyledTableCell>
        <StyledTableCell style={{padding: 10}} align="right">{row.ngram}</StyledTableCell>
        <StyledTableCell style={{padding: 10}} align="right">{row.freq}</StyledTableCell>
      </StyledTableRow>
    ))
  };
  
  const classes = useStyles();
  
  useEffect(() => {
    getRows()
  }, [])

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell style={{padding: 10}}>Sexo</StyledTableCell>
            <StyledTableCell style={{padding: 10}} align="right">Edad</StyledTableCell>
            <StyledTableCell style={{padding: 10}} align="right">Número de palabras</StyledTableCell>
            <StyledTableCell style={{padding: 10}} align="right">Palabra/idea</StyledTableCell>
            <StyledTableCell style={{padding: 10}} align="right">Frecuencia</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            getRows()
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}